import { createFileRoute } from "@tanstack/react-router";
import { AutomationsPage } from "@/components/features/automations/AutomationsPage";
export const Route = createFileRoute("/_auth/automations")({
  component: AutomationsPage,
});
